import Controller from '@ember/controller';
import { get } from '@ember/object';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default Controller.extend({
  router: service(),

  save: task(function* () {
    let changeset = get(this, 'model.changeset');
    yield changeset.validate();
    if (get(changeset, 'isValid')) {
      this.router.transitionTo(
        'funds.fund.groups.group.add',
        get(changeset, 'name'),
      );
    }
  }).drop(),
});
